export default __webpack_public_path__ + "static/media/07-460x460.594909b4.jpeg";